import corePriceFormat from './price-format';

const priceFormat = (...args) => {
  const price = corePriceFormat(...args);
  if (!price) {
    return null;
  }
  return price;
};

const getPricePropsByField = (field, variant) => {
  const obj = {
    ...(variant === 'secondary' ? { returnNullOnSold: true } : {}),
  };
  switch (field) {
    case 'wholesalePrice':
      return {
        ...obj,
        label: 'Handelsprijs',
        field: 'wholesalePrice',
        priceFormat,
      };
    case 'externalLease':
      return {
        ...obj,
        label: 'Financiering',
        field: 'externalLease.price',
        priceFormat,
      };
    case 'privateLease':
      return {
        ...obj,
        label: 'Private lease',
        field: 'privateLease.price',
        note: 'privateLease.note',
        priceFormat,
      };
    case 'lease':
      return {
        ...obj,
        label: 'Private lease',
        field: 'leases.0.maandbedrag',
        priceFormat,
      };
    case 'regularPrice': // @TODO
    case 'salePrice': // @TODO
    case 'exportPrice': // @TODO
    case 'asIsPrice': // @TODO
    case 'lowestPrice':
    default:
      return {
        ...obj,
        label: 'Direct kopen',
        field,
        priceFormat,
      };
  }
};

export default getPricePropsByField;
